import { getHeader, getUserInfo } from "../utility/index";
import axios from "./config";

interface ApiResponse {
    data: any;
}

const supervisorActivity = async (params: any, data: any): Promise<ApiResponse> => {
    const user_info = getUserInfo();
    const response = await axios.post<ApiResponse>(
        `/reports/${user_info.emp_id}/supervisor-activity-report`,
        data,
        { headers: getHeader(), params }
    );
    return response;
};
const supervisorVisit = async (params: any, data: any): Promise<ApiResponse> => {
    const user_info = getUserInfo();
    const response = await axios.post<ApiResponse>(
        `/reports/${user_info.emp_id}/supervisor-visit-summary-report`,
        data,
        { headers: getHeader(), params }
    );
    return response;
};

const getCallPlanReport = async (params: any, data: any): Promise<ApiResponse> => {
  const user_info = getUserInfo();
  const response = await axios.post<ApiResponse>(
      `/supervisors/${user_info.emp_id}/subordinates/call-plan`,
      data,
      { headers: getHeader(), params }
  );
  return response;
};
const supervisorCollectionAudit= async (params: any, data: any): Promise<ApiResponse> => {
    const user_info = getUserInfo();
    const response = await axios.post<ApiResponse>(
        `/reports/${user_info.emp_id}/collection-audit-report`,
        data,
        { headers: getHeader(), params }
    );
    return response;
};
const getCustomerCreationReport = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/reports/${user_info.emp_id}/customer-creation-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};

const getLocationCaptureReport = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/reports/${user_info.emp_id}/location-capture-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};
const getPOReport = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/reports/${user_info.emp_id}/po-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};
const getCollectionReport = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/reports/${user_info.emp_id}/collection-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};

const getSDRActivityReport = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/sdr_reports/${user_info.emp_id}/activity-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};

const getSDRVisitReport = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/sdr_reports/${user_info.emp_id}/visit-summary-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};
const getSDRSummaryReport = async (params: any, data: any): Promise<any> => {
  const user_info = getUserInfo();

  const response = await axios.post<any>(
    `/sdr_reports/${user_info.emp_id}/summary-report`,
    data,
    {
      headers: getHeader(),
      params: params,
    }
  );
  return response.data;
};
const getSupervisorLeaderBoardList = async (
  param: any,
  data: any
): Promise<ApiResponse> => {
  const user_info = getUserInfo();
  const response = await axios.post<ApiResponse>(
    `/supervisors/${user_info.emp_id}/supervisors-leaderboard`,
    data,
    {
      params: param,
      headers: getHeader(),
    }
  );
  return response;
};
const getSDRLeaderBoardList = async (
  param: any,
  data: any
): Promise<ApiResponse> => {
  const user_info = getUserInfo();
  const response = await axios.post<ApiResponse>(
    `/sdr_reports/${user_info.emp_id}/leaderboard`,
    data,
    {
      params: param,
      headers: getHeader(),
    }
  );
  return response;
};

const getSupervisorDashboardKpiData = async (data: any): Promise<ApiResponse> => {
  const user_info = getUserInfo();
  console.log(user_info)

  const response = await axios.post<ApiResponse>(
    `/supervisors/${user_info.emp_id}/supervisor-dashboard`,
    data,
    {
      headers: getHeader(),
    }
  );
  return response;
};

const getCustomerDetails = async (customerId: string): Promise<ApiResponse> => {
  const user_info = getUserInfo();
  const response = await axios.get<ApiResponse>(
    `/supervisors/customer-details/${customerId}`,
    { headers: getHeader() }
  );
  return response;
};

const generateCheckInOtp = async (customerId: string): Promise<ApiResponse> => {
  const user_info = getUserInfo();
  const response = await axios.post<ApiResponse>(
    `/supervisors/check-in-otp`,
    { customer_id: customerId },
    { headers: getHeader() }
  );
  return response;
};

export {
  supervisorActivity,
  supervisorVisit,
  getCallPlanReport,
  getCustomerCreationReport,
  getSupervisorLeaderBoardList,
  getSupervisorDashboardKpiData,
  getCustomerDetails,
  generateCheckInOtp,
  supervisorCollectionAudit,
  getLocationCaptureReport,
  getPOReport,
  getCollectionReport,
  getSDRActivityReport,
  getSDRVisitReport,
  getSDRSummaryReport,
  getSDRLeaderBoardList,
};  